import { AttributeService } from "../service/asyncBatchGetAttributeService";
import { ProfileSettings, UserSettings } from "../types/app.storage.enums";
import { getObjectFromStorage } from "../utils/storagehelper";
import * as validations from "../utils/validations";

export class AttributesFunctions {
  fnBurgissGetAttribute(investId?: any[][], attribute?: string, uniqueCellId?: string) {
    const getattributename = getObjectFromStorage<any>(UserSettings.LstGetFunctionAttributeName).filter(
      (x: any) => x.key.replace("ExcelGetAttributes:", "").toUpperCase().trim() == attribute.toUpperCase().trim()
    )[0];

    const getcustomattributename = getObjectFromStorage<any>(ProfileSettings.LstGetFunctionCustomAttributeName).filter(
      (x: any) => x.referenceName.toUpperCase().trim() == attribute.toUpperCase().trim()
    )[0];
    // const sheetName = await validations.getActiveWorksheet();
    // const currencyHedge = validations.validateCurrencySetVal(sheetName);
    investId = validations.getSingleOrRangeValues(investId);

    // if (currencyHedge.includes("Error")) {
    //   return currencyHedge;
    // } else
    if (investId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + investId.toString().replace("Error", "") + "";
    } else if (investId.toString().includes("Errinvesid")) {
      return "#INVALIDPARAMETERS - " + investId.toString().replace("Errinvesid", "") + "";
    } else if (investId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled calculation not supported";
    } else if (getattributename == null && attribute.toUpperCase().includes("CUSTOM") == false) {
      return "#INVALIDPARAMETERS - Invalid Attribute Name parameter";
    } else if (getcustomattributename == null && getattributename == null) {
      return "#INVALIDPARAMETERS - Invalid Attribute Name parameter";
    } else if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    return new AttributeService().burgissGetAttribute(investId, attribute, uniqueCellId);
  }
}
